import styled from "styled-components";
import { Badge } from "react-bootstrap";

export const SHome = styled.div`
  .container {
    color: var(--text-primary-light) !important;

    .fas {
      cursor: pointer;
    }

    .course-row {
      display: flex;
      align-items: center;

      @media (min-width: 768px) {
        margin-left: 1.5rem;
      }

      .lecture-row {
        display: flex;
        align-items: center;

        @media (min-width: 768px) {
          padding-left: 3rem;
        }
      }
    }
  }
`;

export const SBadge = styled(Badge)`
  background: var(--primary-dark) !important;
  margin-right: 1rem;
  margin-bottom: 0.2rem;
  height: 2rem;
`;
